<form >
  <wd-field-select [title]="'Scelta Automezzo'" [options]="vehicles" ></wd-field-select>
  <wd-field-text [title]="'Targa Automezzo'" placeholder="Inserire la targa del nuovo mezzo: e.g. CRI190AA"></wd-field-text>
  <wd-field-text [title]="'Codice Mezzo'" placeholder="Inserire il codice del nuovo mezzo: e.g. PR129"></wd-field-text>
</form>
